import { CalculationConfig } from '@calculations/types/calculation-config';
import { PriceStrategySnapWorkOrder } from '@snap-types/transforms/price-strategy/shared';
import { Decimal } from '@snap-types/types/decimal';

import { QuoteBuilderRequirementType } from '../../types/state/requirement';

export function transformSnapRequirementToStoreState(
  requirement: PriceStrategySnapWorkOrder['snapOperations'][number]['snapRequirements'][number],
  calculationConfig: CalculationConfig,
): { uuid: string; requirement: QuoteBuilderRequirementType } {
  return {
    uuid: requirement.uuid,
    requirement: {
      uuid: requirement.uuid,

      pieceNo: requirement.pieceNo,
      calcQty:
        requirement.calcQty?.toDecimalPlaces(calculationConfig.decimalPlaces) ??
        new Decimal(1),

      qtyPer: requirement.qtyPer?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),
      qtyPerType: requirement.qtyPerType,
      fixedQty: requirement.fixedQty?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),
      unitMaterialCost: requirement.unitMaterialCost?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),
      unitLaborCost: requirement.unitLaborCost?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),
      unitBurdenCost: requirement.unitBurdenCost?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),
      unitServiceCost: requirement.unitServiceCost?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),
      fixedCost:
        requirement.fixedCost?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? new Decimal(0),
      scrapPercent: requirement.scrapPercent?.toDecimalPlaces(
        calculationConfig.decimalPlaces,
      ),

      part: requirement.part
        ? {
            partId: requirement.part.partId,
            description: requirement.part.description ?? null,
          }
        : null,
    },
  };
}
